import { AuthenticationSchemaIds, AuthenticationTags } from "../../schemas/authentication.const.js";
import { usageId } from '../../constants/usageid.js';
export const dictionary = {
    form: {
        [usageId(AuthenticationSchemaIds.AUTHENTICATION, AuthenticationTags.DEFAULT)]: {
            title: 'Sign-in',
            description: 'The credentials used for authentication.',
            abbr: 'Sign-in',
            cti: 'Please specify your credentials.',
            properties: {
                username: {
                    title: 'Your E-mail',
                    description: 'The e-mail used for signing in.',
                    abbr: 'E-mail',
                    cti: 'Please specify your e-mail address.',
                },
                password: {
                    title: 'Your password',
                    description: 'The password known only to you.',
                    abbr: 'Secret',
                    cti: 'Please specify your password.',
                }
            },
            responses: {
                errors: {
                    default: 'No access.'
                },
                success: 'Sign-in successful.'
            }
        },
        [AuthenticationSchemaIds.GUEST]: {
            title: 'Sign-out',
            description: 'Sign-out to end your session.',
            abbr: 'Sign-out',
            cti: 'Please click the \'Sign-out\' button to sign out.',
            properties: {},
            responses: {
                errors: {
                    default: 'Failure.'
                },
                success: 'Sign-out successful.'
            }
        },
        [usageId(AuthenticationSchemaIds.UPDATE_SECRET, AuthenticationTags.DEFAULT)]: {
            title: "Update your password",
            description: 'The new password and the old password that will be replaced.',
            abbr: 'Update password',
            cti: 'Please specify your old and your new replacement password.',
            properties: {
                oldSecret: {
                    title: 'Your current password',
                    description: 'The current password known only to you.',
                    abbr: 'Current password',
                    cti: 'Please specify your current password.',
                },
                newSecret: {
                    title: 'Your new password',
                    description: 'The new desired password to use.',
                    abbr: 'New password',
                    cti: 'Please specify your new password.',
                },
                retypeSecret: {
                    title: 'Re-type new password',
                    description: 'The confirmation of new password.',
                    abbr: 'Re-type new password',
                    cti: 'Please re-type your new password.',
                }
            }
        },
        [usageId(AuthenticationSchemaIds.EMAIL, AuthenticationTags.RESET_SECRET)]: {
            title: "Forgot password",
            description: 'A new password will be sent to given e-mail address.',
            abbr: 'Reset password',
            cti: 'Please specify your e-mail.',
            properties: {
                email: {
                    title: 'Your e-mail',
                    description: 'Your e-mail to sent the new password to.',
                    abbr: 'Your e-mail',
                    cti: 'Please specify your e-mail.',
                }
            }
        },
        [usageId(AuthenticationSchemaIds.EMAIL, AuthenticationTags.RESET_VALIDATION)]: {
            title: "Restart e-mail validation",
            description: 'A new validation e-mail will be sent to given e-mail address.',
            abbr: 'Revalidate e-mail',
            cti: 'Please specify your e-mail.',
            properties: {
                email: {
                    title: 'Your e-mail',
                    description: 'Your e-mail to sent the validation request to.',
                    abbr: 'Your e-mail',
                    cti: 'Please specify your e-mail.',
                }
            }
        },
        [usageId(AuthenticationSchemaIds.EMAIL, AuthenticationTags.UPDATE_EMAIL)]: {
            title: "Update your e-mail",
            description: 'The e-mail will replace your current e-mail.',
            abbr: 'Update e-mail',
            cti: 'Please specify your new replacement e-mail.',
            properties: {
                email: {
                    title: 'Your new e-mail',
                    description: 'The new desired e-mail to use.',
                    abbr: 'New e-mail',
                    cti: 'Please specify your new e-mail.',
                }
            }
        },
    },
};
